export const errorTranslations = {
  // General errors
  AnErrorOccurred: '오류가 발생했습니다!',
  ErrorOccurred: '다음과 같은 오류가 발생했습니다',
  PleaseTryAgain: '다시 시도해 주세요',

  // File upload errors
  FileUploadFailed: '파일 업로드에 실패했습니다!',
  FailedToUploadArticle: '파일 업로드에 실패했습니다',
  UploadError: '파일 업로드에 실패했습니다',
  FileTooLarge: '파일이 너무 큽니다. 최대 5MB 크기 제한',
  FileSizeError:
    '파일 크기가 5MB를 초과합니다. 지원되는 크기 내에서 다시 업로드해 주세요',
  LongFileError: '파일이 너무 깁니다. 허용된 길이 내에서 다시 업로드해 주세요',
  ImageFileUploadError: '이미지 파일은 업로드할 수 없습니다',
  InvalidFileFormat: '지원되는 파일 유형: pdf, doc, docx, txt, ppt, pptx',
  FileSizeLimitError: '최대 파일 크기는 15MB입니다',
  FileCountLimitError: '최대 저장 가능한 파일 개수는 20개입니다',
  YouCanOnlyUploadTenFiles: '파일 10개만 업로드 가능합니다!',

  // Deletion errors and confirmations
  DeletionFailed: '삭제에 실패하였습니다',
  FailedToDeleteBookmark: '북마크 삭제에 실패하였습니다',
  DeleteDocumentError: '문서 삭제에 실패했습니다',
  ItHasBeenDeleted: '삭제되었습니다.',
  BookmarkHasBeenDeleted: '북마크가 삭제되었습니다.',
  AreYouSureYouWantToDeleteThisFile: '이 파일을 삭제하시겠습니까?',
  WhenDeletedFileRemoveeFromTheProject:
    '삭제하면 프로젝트에서 파일이 제거됩니다.',
  DeleteFile: '삭제하기',
  // Authorization errors
  UnauthorizedAccess: '접근 권한이 없습니다',

  // Query validation errors
  QueryIsEmpty: '쿼리가 비어 있습니다',
  PleaseSelectAtLeastOneSource: '소스를 하나 이상 선택하세요!',
  pleaseSelectSource: '소스를 하나 이상 선택하세요',

  // URL validation errors
  PleaseEnterAValidURL: '유효한 URL을 입력하세요',
  WebsiteLinkError:
    '이 URL의 콘텐츠를 요약할 수 없습니다. 다른 URL을 입력하거나 다시 시도해 주세요',

  // Content validation errors
  PleaseEnterTheTextYouWantToTranslate: '번역할 텍스트를 입력해 주세요',
  PleaseEnterTextToSummarize: '요약할 텍스트를 입력해 주세요',

  // Date validation errors
  PleaseEnterADate: '날짜를 입력해 주세요',
  PleaseUseYYYYMMDDFormat: 'YYYY/MM/DD 형식으로 입력해 주세요',

  // No results found
  NoResultsFound: '검색 결과가 없습니다',
  NoSearchResultsFound: '검색 결과가 없습니다',
  NoArticlesFoundForTheSelectedFilters:
    '선택한 필터에 대한 기사를 찾을 수 없습니다',

  // Content availability errors
  NoBookmarksAvailable: '북마크 자료가 없습니다!',
  NoArticlesAvailable: '자료가 없습니다!',
  NoWorkspacesFound: '워크스페이스가 없습니다',
  NoProjectsFound: '프로젝트가 없습니다',
  NoDocuments: '내부 문서를 먼저 업로드 해주세요',
  NofilesUploadsYet: '아직 파일이 업로드되지 않았습니다',

  // Limit errors
  MaxWorkspaceReached: '현재 최대 워크스페이스 개수는 2개 입니다',

  // Preview and display errors
  FilePreviewNotAvailable: '파일 미리보기가 지원되지 않습니다',
  ImageLoadError: '이미지를 불러올 수 없습니다',
  ErrorOccured: '오류가 발생했습니다',

  // Update errors
  FailedToUpdateINDDraft: '업데이트에 실패했습니다',
  FailedToFetchINDDraft: '초안을 가져오지 못했습니다.',

  // Generation errors
  InvalidCSRINDFileFormat: '지원되는 파일 유형: pdf, doc, docx, rtf',
  GenerationError: '생성 오류',
  ThereWasAnErrorGeneratingTheContent:
    '프롬프트를 처리하는 중 문제가 발생했습니다. 다시 시도해 주세요.',
  Retry: '다시 시도',
  Retrying: '다시 시도 중...',

  // Error Boundary
  AccessDenied: '접근 권한이 없습니다',
  AccessDeniedSubtitle: '요청하신 문서에 접근 권한이 없습니다.',
  PageNotFound: '페이지를 찾을 수 없습니다',
  PageNotFoundSubtitle: '요청하신 페이지를 찾을 수 없습니다.',
  InternalServerError: '서버 오류가 발생했습니다',
  InternalServerErrorSubtitle: '서버 오류가 발생했습니다.',
  BackToProjects: '프로젝트로 돌아가기',
  BackToPreviousPage: '이전 페이지로 돌아가기',
}
